export default __webpack_public_path__ + "static/media/logo-light.e5554b41.svg";